export const ID_TYPE_LABELS = {
  RC: 'Registro Civil',
  TI: 'Tarjeta de Identidad',
  CC: 'Cédula de Ciudadanía',
  CE: 'Cédula de Extranjería',
  PAS: 'Pasaporte',
  PPT: 'Permiso por protección temporal (PPT)',
  RUMV: 'Registro Único de Migrantes Venezolanos (RUMV)'
};

export function getIdentificationTypeLabel(code) {
  return ID_TYPE_LABELS[code] || code || '';
}

export function ensureIdentificationTypeOptions(options = []) {
  const hasRumv = options.some(option =>
    String(option?.id ?? option?.code ?? '').trim().toUpperCase() === 'RUMV'
  );
  if (hasRumv) return options;
  return [
    ...options,
    {id: 'RUMV', value: ID_TYPE_LABELS.RUMV}
  ];
}
